export class ExternalAppDto{

  showApp: boolean;
  url: string;
  icon: string;
  wcagicon: string;
  showIcon: boolean;
  name: string;

  constructor(attr: {showApp: boolean, url: string, icon: string, wcagicon: string, showIcon: boolean, name: string}){
      this.showApp = attr.showApp;
      this.url = attr.url;
      this.icon = attr.icon;
      this.wcagicon = attr.wcagicon;
      this.showIcon = attr.showIcon;
      this.name = attr.name;
  }

}
